import { useEffect } from 'react';
import { useStateInRef } from 'seagull';
import { useStore } from '~/contexts';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { PusherEvent, useBusinessChannelEventBinder } from '~/pusher';
import { selectors } from '~/store/state-selectors';
import { markContactEmailUpdateComplete } from './usePendingContactEmailUpdates';
export function usePendingContactEmailUpdatesListener() {
    const isAuthenticated = useStore(selectors.user.hasUserInfo);
    const isReviewer = useStore(selectors.user.isReviewer);
    const { refresh } = useContacts({
        enabled: isAuthenticated && !isReviewer
    });
    const { startListening } = useBusinessChannelEventBinder(PusherEvent.ContactUpdated, 'mgmt');
    const getOnContactUpdated = useStateInRef((event)=>{
        if (isReviewer) return;
        markContactEmailUpdateComplete(event.payload.contactUpdated.userId);
        refresh();
    });
    useEffect(()=>{
        startListening((event)=>getOnContactUpdated()(event));
    }, []);
}
